interface Breadcrumb {
  category: string;
  action: string;
  data?: Record<string, unknown>;
}

// Default-on when Sentry DSN is present; avoids managing extra feature flags
const FLAG = Boolean(import.meta.env.VITE_SENTRY_DSN);
import { logger } from '@/lib/logger';

export function addBreadcrumb(category: string, action: string, data?: Record<string, unknown>): void {
  if (!FLAG) return;
  try {
    // Metadata only; avoid PII in data
    const payload: Breadcrumb = { category, action, data };
    logger.debug('[breadcrumb]', { breadcrumb: payload });
  } catch {
    // no-op
  }
}


